var lib_core = require("lib-core");

var SymbolTerminalInstance = function () {
    lib_core.AbstractInstance.call(this);

    this.onInit("init", this.initialize);
};
lib_core.inherit(SymbolTerminalInstance, lib_core.AbstractInstance);
SymbolTerminalInstance.$class = "SymbolTerminalInstance";

module.exports = SymbolTerminalInstance;
SymbolTerminalInstance.$class = "SymbolTerminalInstance";

SymbolTerminalInstance.prototype.initialize = function () {
    this.pos = this.shadow("pos",
        function(){
            return this.description.pos().rotate(this.parent().angle()).add(this.parent().pos());
        },
        null,
        [this.parent().pos, this.parent().angle]
    );

    this.angle = this.shadow("angle",
        function(){
            return this.description.angle() + this.parent().angle();
        },
        null,
        [this.parent().angle]
    );
};
